<template>
  <v-container fluid>
    <v-card>
      <v-toolbar :color="$store.state.UiColors.crudToolbarList">
        <v-icon>list</v-icon>
        <v-toolbar-title class="font-weight-light"
          >Detalle de la Venta</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-btn
          :color="$store.state.UiColors.crudToolbarDetailButtons"
          fab
          small
          top
          @click="closeDialog"
        >
          <v-icon>cancel</v-icon>
        </v-btn>
      </v-toolbar>

      <v-data-table
        dense
        :headers="headers"
        :items="records"
        :loading="loading"
      >
        <template v-slot:item="{ item }">
          <tr>
            <!-- no se si dejarlo o sacarlo el acciones comunes  -->
            <td>
              <app-acciones-comunes
                :documento="item.cuil.toString().substring(2, 10)"
                :solicitudId="item.id"
                :ocultarAnalisisConsulta="true"
                :ocultarAnalisisCredito="true"
                :ocultarVerLegajoVirtual="true"
              >
              </app-acciones-comunes>
            </td>

            <td class="text-xs-left caption">
              <tr>
                {{
                  item.origen
                }}
              </tr>
              <tr class="text-xs-left font-weight-light caption">
                {{
                  item.producto
                }}
                /
                {{
                  item.planNombre
                }}
              </tr>
            </td>

            <td class="text-xs-left caption">{{ item.cuil }}</td>
            <td class="text-xs-left caption">{{ item.solicitante }}</td>
            <td class="text-xs-left caption">{{ item.numeroCredito }}</td>
            <td class="text-xs-left caption">
              {{
                item.fechaIngreso
                  | dateParse('YYYY-MM-DD')
                  | dateFormat('DD-MM-YYYY')
              }}
            </td>
            <td class="text-xs-left caption">
              <tr>
                {{
                  item.cuotas
                }}
                de
              </tr>
              <tr>
                {{
                  item.importeCuota | currency
                }}
              </tr>
            </td>

            <td class="text-xs-left caption">{{ item.cuotaDesde }}</td>
            <td class="text-xs-left caption">{{ item.valor | currency }}</td>
            <td class="text-xs-left caption">
              {{ item.valorCapital | currency }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  data: () => ({
    loading: false,
    options: {
      // definición de paginación
      sortDesc: [false],
      sortBy: [''],
      page: 1,
      itemsPerPage: 24,
      rowsPerPageItems: [6, 12, 24],
    },
    totalItems: 0, // va afuera de pagination
    headers: [
      // definición de columnas
      { text: 'Ver', value: 'accion', width: 80, sortable: false },
      { text: 'Origen', value: 'origen' },
      { text: 'Cuil', value: 'cuil' },
      { text: 'Nombre', value: 'solicitante' },
      { text: 'Número', value: 'numero' },
      { text: 'Fecha de Ingreso', value: 'fechaIngreso' },
      { text: 'Cuotas Originales', value: 'cuotas', width: 130 },
      { text: 'Cuota Desde', value: 'cuotaDesde' },
      { text: 'Valor', value: 'valor', width: 130 },
      { text: 'Valor Capital', value: 'valorCapital', width: 130 },
    ],
    records: [],
  }),
  props: {
    ventaCarteraId: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
    },
  },
  watch: {
    /*   'ventaCarteraId' : function(){
          this.loadDetalleVenta();
      }, */
    show: function() {
      Vue.$log.debug(this.show);
      if (this.show) this.loadDetalleVenta();
    },
  },
  methods: {
    async loadDetalleVenta() {
      this.loading = true;

      try {
        var result = await http.get(
          'ventasCartera/getdetalle?ventaCarteraId=' + this.ventaCarteraId
        );

        Vue.$log.debug(result);
        this.records = result.list;
      } catch (error) {
        // Error
        Vue.$log.error(error);
        this.alertError(error);
      }

      this.loading = false;
    },
    closeDialog() {
      this.$emit('close-dialog');
    },
  },
};
</script>
